import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { Observable, map } from "rxjs";
import { AuthenticationService } from "src/app/shared/services";

@Injectable({ providedIn: 'root' })
export class TenantResolver implements Resolve<string> {
    /**
     *
     */
    constructor(private readonly authService: AuthenticationService) {
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): string | Observable<string> | Promise<string> {
        const tenant = route.paramMap.get('tenant');

        return this.authService.getBusinessPartner(tenant)
            .pipe(
                map(result => result.data.tag)
            );
    }

}